import React from "react";
import { Eye, Volume2, VolumeX, Contrast, AudioWaveform, GraduationCap } from "lucide-react";

export const AccessibilityBar = ({
    ttsEnabled, setTTSEnabled,
    hcMode, setHCMode,
    audioEnabled, setAudioEnabled,
    practiceMode, setPracticeMode,
}) => {
    return (
        <div
            className="flex items-center gap-2 text-[10px] tracking-[0.2em] uppercase flex-wrap"
            data-testid="accessibility-bar"
        >
            {setPracticeMode && (
                <button
                    onClick={() => setPracticeMode(v => !v)}
                    className={`dial-btn px-3 py-1.5 flex items-center gap-1.5 ${practiceMode ? "selected" : ""}`}
                    aria-pressed={practiceMode}
                    aria-label="Toggle practice mode hints"
                    data-testid="toggle-practice-mode"
                >
                    <GraduationCap size={12} />
                    <span>Practice {practiceMode ? "ON" : "OFF"}</span>
                </button>
            )}
            {setAudioEnabled && (
                <button
                    onClick={() => setAudioEnabled(v => !v)}
                    className="dial-btn px-3 py-1.5 flex items-center gap-1.5"
                    aria-pressed={audioEnabled}
                    aria-label="Toggle ambient sound"
                    data-testid="toggle-audio"
                >
                    <AudioWaveform size={12} />
                    <span>Sound {audioEnabled ? "ON" : "OFF"}</span>
                </button>
            )}
            <button
                onClick={() => setHCMode(v => !v)}
                className="dial-btn px-3 py-1.5 flex items-center gap-1.5"
                aria-pressed={hcMode}
                aria-label="Toggle high contrast mode"
                data-testid="toggle-high-contrast"
            >
                <Contrast size={12} />
                <span>HC {hcMode ? "ON" : "OFF"}</span>
            </button>
            <button
                onClick={() => setTTSEnabled(v => !v)}
                className="dial-btn px-3 py-1.5 flex items-center gap-1.5"
                aria-pressed={ttsEnabled}
                aria-label="Toggle text to speech narration"
                data-testid="toggle-tts"
            >
                {ttsEnabled ? <Volume2 size={12} /> : <VolumeX size={12} />}
                <span>TTS {ttsEnabled ? "ON" : "OFF"}</span>
            </button>
            <span className="hidden sm:inline-flex items-center gap-1.5 text-[var(--text-muted)] ml-2">
                <Eye size={12} /> A11y
            </span>
        </div>
    );
};

export default AccessibilityBar;
